import * as css from '../ETicket.css';

function BrandHeader() {
    return (
        <css.brandHeader>
            <css.brandLogo />
        </css.brandHeader>
    );
}

export default BrandHeader;
